module.exports = __webpack_public_path__ + "images/eligibility_analysis.836795000b39227c4dd7c192c6834a7e.svg";